import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

interface TimeTrackingDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateTask: () => void;
  assigneeName?: string;
  isSubTask?: boolean;
}

const TimeTrackingDialog: React.FC<TimeTrackingDialogProps> = ({
  open,
  onClose,
  onCreateTask,
  assigneeName,
  isSubTask,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#ff5252",
          color: "white",
          display: "flex",
          alignItems: "center",
          p: 2,
        }}
      >
        <HourglassEmptyIcon sx={{ mr: 1, color: "white" }} />
        {`Time Tracking Restriction`}
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", py: 3, px: 4 }}>
        <p style={{ fontSize: "1.1rem", color: "#555", marginTop: "1.5rem" }}>
          You're not allowed to log time on this task because it's assigned to{" "}
          <span style={{ color: "#007FFF" }}>
            {assigneeName || "another person."}
          </span>
          .
        </p>
        <p style={{ fontSize: "1rem", color: "#777" }}>
          {`Please create a ${
            isSubTask ? "subtask" : "task"
          } to log your time.`}
        </p>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3, px: 4 }}>
        <Button
          onClick={onCreateTask}
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            borderRadius: 8,
            px: 3,
            py: 1.5,
            backgroundColor: "#007FFF",
            "&:hover": {
              backgroundColor: "#005bb5",
            },
          }}
        >
          {`Click here to create a ${isSubTask ? "subtask" : "task"}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeTrackingDialog;
